<template>
  <div class="callers-collapse">
    <div class="callers-collapse__main">
      <div class="callers-collapse__item">
        <span class="callers-collapse__name"></span>
        <span class="callers-collapse__value">{{ item[0] }}</span>
      </div>
      <b-collapse id="collapse" v-model="is_collapse" class="callers-collapse__content">
        <div class="callers-collapse__item">
          <span class="callers-collapse__value">{{ item.slice(1).join(' ') }}</span>
        </div>
      </b-collapse>
    </div>
    <div v-if="item.length > 1" class="callers-collapse__controls">
      <icon
        :type="!is_collapse ? 'ios-arrow-down' : 'ios-arrow-up'"
        class="callers-collapse__controls-icon"
        @click="is_collapse = !is_collapse"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Array,
        default: () => ({})
      }
    },

    data: () => ({
      is_collapse: false
    })
  };
</script>

<style lang="scss" scoped>
  .callers-collapse {
    display: flex;
    width: 100%;

    &__main {
      flex: auto;
    }

    &__controls {
      align-self: center;
    }

    &__controls-icon {
      font-size: 18px;

      &:hover {
        cursor: pointer;
      }
    }

    &__content {
      .callers-collapse__item {
        margin-top: 10px;
      }
    }

    &__item {
      display: flex;
      flex-direction: column;
    }

    &__name {
      color: #a0a0a0;
    }
  }
</style>